<template>
  <el-card class="box-card">
    <template #header>
      <div>系统设置</div>
    </template>
    <el-form :model="form" label-width="120px">
      <el-form-item label="网站名称">
        <el-input v-model="form.website_name" />
      </el-form-item>
      <el-form-item label="网站地址">
        <el-input v-model="form.website_url" />
      </el-form-item>
      <el-form-item label="关键词">
        <el-input v-model="form.keywords" />
      </el-form-item>
      <el-form-item label="网站摘要">
        <el-input type="textarea" v-model="form.description" />
      </el-form-item>
      <el-form-item label="积分兑换比例">
        <el-input-number v-model="form.points_exchange_rate" :min="1" :max="100000" />
        <div class="hint">1元余额可兑换的积分数，默认 100</div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="loading" @click="submit">保存</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script setup>
import { reactive, ref, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import request from '../../utils/request'
import axios from 'axios'

const form = reactive({
  website_name: '',
  website_url: '',
  keywords: '',
  description: '',
  points_exchange_rate: 100
})

const loading = ref(false)

const load = async () => {
  loading.value = true
  try {
    const res = await axios.get(
      process.env.VUE_APP_BASE_API + '/v1/config/view'
    )
    const data = res.data.data || res.data
    Object.assign(form, data || {})
  } catch (e) {
    ElMessage.error(e)
  } finally {
    loading.value = false
  }
}

const submit = async () => {
  loading.value = true
  try {
    await request.post('/v1/config/update', form)
    ElMessage.success('保存成功')
  } catch (e) {
    ElMessage.error(e)
  } finally {
    loading.value = false
  }
}

onMounted(load)
</script>

<style scoped>
.hint {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
}
</style>
